import { useEffect, useState } from "react";

const useSeo = (fetchSeoFunction) => {
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    let isMounted = true;                     // ← avoids setting state after unmount
    const fetchSeo = async () => {
      try {
        const response = await fetchSeoFunction();
        console.log("Raw SEO response:", response); // debugging
        if (isMounted && response) {          // ← just test for truthy
          setSeoData(response);               // ← store it directly
        }
      } catch (error) {
        console.error("SEO fetch failed:", error);
      }
    };

    fetchSeo();
    return () => { isMounted = false; };      // cleanup
  }, [fetchSeoFunction]);

  return seoData;
};

export default useSeo;